import { useParams } from "react-router";
import { FILE_BROWSER_ROUTES } from "../../../../constants";
import { useReportDispatch } from "../../../hooks";
import { generateFileBrowserTabLink } from "../../../utils";
import { filterByMlDetected } from "../../store/behaviorSlice";
import { filterByLicenseFamily, filterByLinkingTypeAndLicenseFamily, filterByMalicious, } from "../../store/dependenciesSlice";
import { filterByLiveness, filterByService, hideTriagedUpdated, } from "../../store/secretsSlice";
import { filterByExploitTag, filterBySeverity, } from "../../store/vulnerabilitiesSlice";
export function usePolicyMappings() {
    const dispatch = useReportDispatch();
    const { fileId = "" } = useParams();
    const behaviorsLink = {
        text: "Behaviors",
        to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.BEHAVIOR_ROUTE),
    };
    const dependenciesLink = {
        text: "Dependencies",
        to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.DEPENDENCIES_ROUTE),
    };
    const secretsLink = {
        text: "Secrets",
        to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.SECRETS_ROUTE),
    };
    const vulnerabilitiesLink = {
        text: "Vulnerabilities",
        to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.VULNERABILITIES_ROUTE),
    };
    return {
        SQ30205: {
            ...dependenciesLink,
            onClick: () => dispatch(filterByMalicious(true)),
        },
        SQ30108: {
            ...behaviorsLink,
            onClick: () => dispatch(filterByMlDetected(true)),
        },
        SQ31101: {
            ...vulnerabilitiesLink,
            onClick: () => dispatch(filterByExploitTag("MANDATE")),
        },
        SQ31102: {
            ...vulnerabilitiesLink,
            onClick: () => dispatch(filterByExploitTag("EXISTS")),
        },
        SQ31103: {
            ...vulnerabilitiesLink,
            onClick: () => dispatch(filterByExploitTag("MALWARE")),
        },
        SQ31104: {
            ...vulnerabilitiesLink,
            onClick: () => dispatch(filterBySeverity("critical")),
        },
        SQ31105: {
            ...vulnerabilitiesLink,
            onClick: () => dispatch(filterBySeverity("high")),
        },
        SQ31106: {
            ...vulnerabilitiesLink,
            onClick: () => dispatch(filterBySeverity("medium")),
        },
        SQ31107: {
            ...vulnerabilitiesLink,
            onClick: () => dispatch(filterBySeverity("low")),
        },
        SQ12101: {
            text: "License",
            to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.INFO_ROUTE),
        },
        SQ12102: {
            ...dependenciesLink,
            text: "Dependency license",
            onClick: () => dispatch(filterByLicenseFamily("Copyleft")),
        },
        SQ12103: {
            ...dependenciesLink,
            text: "Dependency license",
            onClick: () => dispatch(filterByLinkingTypeAndLicenseFamily({
                linkingType: "static",
                licenseFamily: "Weak Copyleft",
            })),
        },
        SQ34102: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34103: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34104: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34105: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34106: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34107: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34108: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34109: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34110: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34111: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34253: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("inactive")),
        },
        SQ34254: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("inactive")),
        },
        SQ34255: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("inactive")),
        },
        SQ34256: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("inactive")),
        },
        SQ34301: {
            ...secretsLink,
            onClick: () => dispatch(filterByService("Networking placeholder")),
        },
        SQ34302: {
            ...secretsLink,
            onClick: () => dispatch(filterByService("Networking credential")),
        },
        SQ34303: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34304: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34305: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34306: {
            ...secretsLink,
            onClick: () => dispatch(hideTriagedUpdated(false)),
        },
        SQ34401: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("active")),
        },
        SQ34402: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("active")),
        },
        SQ34403: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("active")),
        },
        SQ34404: {
            ...secretsLink,
            onClick: () => dispatch(filterByLiveness("active")),
        },
    };
}
//# sourceMappingURL=PolicyMappings.js.map